import { useState as i, useRef as w, useCallback as u } from "react";
function m() {
  const [e, a] = i(null), [s, o] = i(!1), n = w([]), c = u(() => {
    if (n.current.length > 0) {
      const t = n.current.shift();
      t && (a(t), o(!0));
    }
  }, []), f = u(
    (t) => {
      o(t), t || setTimeout(c, 100);
    },
    [c]
  ), l = u(
    (t, T, h, p) => {
      const r = { id: Date.now(), status: t, text: T, link: h, isStatic: p };
      !e || !s ? (a(r), o(!0)) : n.current.push(r);
    },
    [e, s]
  );
  return {
    activeToast: e,
    open: s,
    handleOpenChange: f,
    showToast: l
  };
}
export {
  m as useToastProvider
};
